import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "knowledge-test__footer" }
const _hoisted_2 = { class: "knowledge-test__progress" }
const _hoisted_3 = ["value", "max", "aria-label"]
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_i18n_t, {
          keypath: "Отвечено {answered} из {total}",
          tag: "span"
        }, {
          answered: _withCtx(() => [
            _createElementVNode("b", null, _toDisplayString(_ctx.answered), 1)
          ]),
          total: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.total), 1)
          ]),
          _: 1
        }),
        _createElementVNode("span", null, _toDisplayString(_ctx.message), 1)
      ]),
      _createElementVNode("progress", {
        value: _ctx.answered,
        max: _ctx.total,
        "aria-label": _ctx.$t('Отвечено {answered} из {total}', { answered: _ctx.answered, total: _ctx.total })
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("button", {
      type: "submit",
      class: "knowledge-test__button",
      disabled: _ctx.disabled
    }, _toDisplayString(_ctx.$t(_ctx.submitting ? "Отправка…" : "Завершить тест")), 9, _hoisted_4)
  ]))
}